



























































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Building } from '@/modules/backend/Entities/Building';
import BuildingAddDialog from '@/components/buildings/BuildingAddDialog.vue';
import BuildingDeleteButton from '@/components/buildings/BuildingDeleteButton.vue';
import { Company } from '@/modules/backend/Entities/Company';
import { BuildingsModule } from '@/store/dashboard/buildings/BuildingsModule';
import { resolveModule } from '@/store';
import DataTableWrapper from '@/layouts/DataTableWrapper.vue';
import { DataTableHeader } from 'vuetify';
import Mixin from '@/mixins/base';
import { emptyPlaceholder } from '@/filters/emptyPlaceholder';

const AuthModule = namespace('app/auth');

@Component({
  mixins: [Mixin],
  filters: { emptyPlaceholder },
  components: {
    DataTableWrapper,
    'building-add-dialog': BuildingAddDialog,
    'building-delete-button': BuildingDeleteButton
  }
})
export default class CompanyBuildings extends Mixins(Mixin) {
  private readonly buildingsModule: BuildingsModule = resolveModule(BuildingsModule);

  private loading = false;

  @AuthModule.Getter('CompanyById')
  private companyById!: (companyId: number) => Company;

  get companyId(): number | undefined {
    return this.$route.params.companyId
      ? Number(this.$route.params.companyId)
      : undefined;
  }

  get currentCompany(): Company | undefined {
    if (this.companyId) {
      return this.companyById(Number(this.companyId));
    }

    return undefined;
  }

  get buildingList(): Array<Building> {
    return this.buildingsModule.BuildingsByCompanyId(Number(this.companyId));
  }

  private get headers(): DataTableHeader[] {
    return [
      {
        text: this.isDesktop ? this.$t('common.table.headers.id').toString() : this.$t('common.table.headers.id_short').toString(),
        sortable: false,
        value: 'id'
      },
      {
        text: this.$t('screens.buildings.dialog_fields.address').toString(),
        value: 'address'
      },
      {
        text: this.$t('screens.buildings.dialog_fields.providers').toString(),
        value: 'providers'
      },
      {
        text: this.$t('common.table.headers.actions').toString(),
        sortable: false,
        value: 'actions',
        align: 'end'
      }
    ];
  }

  private async loadData(): Promise<void> {
    this.loading = true;
    await this.buildingsModule.Fetch(Number(this.companyId));
    this.loading = false;
  }

  @Watch('companyId', { immediate: true })
  private async companyChangedHandler(): Promise<void> {
    await this.loadData();
  }
}
